<template>
  <v-row>
    <v-col cols="auto" class="py-1">
      <span
        style="
          font-family: Inter;
          font-size: 0.875rem;
          font-weight: 400;
          margin-right: 4px;
        "
      >
        {{ alert.url }}</span
      >
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="auto" class="py-1">
      <span :style="connectsStyle">
        {{ connectsValue }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    alert: {
      type: Object,
      default() {
        return {};
      },
    },
    node: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    connectsValue() {
      let value = this.$store.state.metrics.metric[this.alert.id];
      if (value == '1') {
        return 'Available';
      } else {
        return 'Unavailable';
      }
    },
    connectsStyle() {
      let value = this.connectsValue;
      let color;
      if (value === 'Available') {
        color = 'hsl(120, 67%, 39%)';
      } else if (value === 'Unavailable') {
        color = 'hsl(0, 87%, 59%)';
      } else {
        color = 'hsl(0, 0%, 59%)';
      }
      return {
        fontFamily: 'Inter',
        fontSize: '0.875rem',
        fontWeight: '600',
        color: color,
      };
    },
  },
};
</script>
